import type { Theme } from "../tokens";

/** Mirror's Edge logic. The world is grey; four colours mean one thing each. */
export const beacon: Theme = {
  id: "beacon",
  name: "Beacon",
  thesis: "Mirror's Edge logic. The world is grey; four colours mean one thing each.",
  scheme: "light",
  colors: {
    ground: "#F2F2F0",
    surface: "#FFFFFF",
    raised: "#F6F6F4",
    ink: "#101010",
    dim: "#6B6B68",
    rule: "#E0E0DC",
    lattice: "#EDEDEA",
    focus: "#0066FF",
    inbox: "#FF3B00",
    feed: "#0066FF",
    paperTrail: "#767C82",
    screener: "#8A6200",
  },
  type: {
    sans: "'Inter', system-ui, sans-serif",
    mono: "'Space Grotesk', system-ui, sans-serif",
    googleFonts: "Space+Grotesk:wght@500;700&family=Inter:wght@400;600",
    tracking: "0",
  },
  density: {
    row: 44,
    primary: 15,
    secondary: 14,
    meta: 12,
    listWidth: 800,
    rail: 204,
    radius: 0,
    lineHeight: 1.4,
  },
  markers: {
    inbox: "●",
    feed: "◆",
    paperTrail: "▭",
    screener: "▲",
  },
};
